export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70ee4797b05d90c0c72680628a9a987d569b67c3bc&name=pushAdClickData!'